/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import { trackedTask } from 'reactiveweb/ember-concurrency';

import phorestLogo from 'my-phorest/assets/images/phorest-logo-electron.svg';
import refreshIcon from 'my-phorest/assets/images/status-bar-refresh.svg';
import collapseIcon from 'my-phorest/assets/images/status-bar-collapse.svg';

export default class PageTitleBarComponent extends Component {
  @service('browser/window') window;
  @service electronApp;
  @service intl;
  @service notifications;
  @service platform;
  @service sidebar;

  phorestLogoSrc = phorestLogo;
  refreshIconSrc = refreshIcon;
  collapseIconSrc = collapseIcon;

  appVersion = trackedTask(this, this.getElectronAppVersionTask, () => []);

  get isSidebarOpen() {
    return this.sidebar.isOpen;
  }

  get showTitleBar() {
    return (
      this.electronApp.isRunningInElectron && this.electronApp.hasCustomTitleBar
    );
  }

  get isWindows() {
    return this.platform.isWindows;
  }

  @action
  refresh() {
    this.window.location.reload(true);
  }

  @action
  toggleSidebar() {
    this.sidebar.toggleSidebar();
  }

  @action
  copyVersionToClipboard() {
    this.window.navigator.clipboard
      .writeText(this.appVersion.value)
      .then(() => {
        this.notifications.success(
          this.intl.t('global.copied'),
          this.intl.t('titlebar.version-copied-to-clipboard')
        );
      })
      .catch(() => {
        console.error('Could not copy app version to clipboard');
      });
  }

  @task
  *getElectronAppVersionTask() {
    return yield this.electronApp.getVersion();
  }
}
